import { ArrowLeft } from 'lucide-react';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Routes } from '@/config/Routes';
import { AuthLayout } from '@/features/auth/components/AuthLayout';

export const Route = createFileRoute('/request-access')({
	component: RequestAccessPage,
});

function RequestAccessPage() {
	const { t } = useTranslation('auth');

	return (
		<AuthLayout>
			<div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
				<h1 className="text-2xl font-bold">{t('requestAccess.title')}</h1>
				<p className="text-muted-foreground text-sm">{t('requestAccess.description')}</p>
				<Link to={Routes.LOGIN} className="mt-4 inline-flex items-center gap-2 text-sm underline-offset-4 hover:underline">
					<ArrowLeft className="h-4 w-4" />
					{t('requestAccess.backToLogin')}
				</Link>
			</div>
		</AuthLayout>
	);
}
